// extracted by mini-css-extract-plugin
export default {"root":"i2z9XAwb7VpNM81n5nvw","wrapper":"Bp7RI2bM0m_apbnvfL4A","inner":"skYHcPdQ6RBus8UVR7AE"};